import React, { useEffect, useState, useCallback, memo } from "react";

import { EntryOption, OptionList, OptionFooter } from "components/EntryOption";
import { BackToLinkButton } from "basics/buttons";
import OptionLoader from "loader/SquareLoader";
import useEntryForm from "hooks/useEntryForm";
import useScroll from "hooks/useScroll";

export function InternalTopics({ onSelected }) {
  const [topics, setTopics] = useState([]);
  const { scrollRef, scrollToRef } = useScroll();

  const { loadingTopics, getTopics } = useEntryForm();

  const handleTopics = useCallback(() => {
    getTopics().then((topics) => {
      setTopics(topics);
      scrollToRef();
    });
  }, [getTopics, scrollToRef]);

  useEffect(() => {
    handleTopics();
  }, [getTopics, handleTopics]);

  return (
    <div ref={scrollRef}>
      {loadingTopics ? (
        <OptionLoader counter={3} />
      ) : (
        <OptionList>
          {topics.map((topic) => (
            <EntryOption
              key={topic.id}
              kind="Temática"
              title={topic.title}
              description={topic.description}
              onSelect={() => onSelected({ id: topic.id, title: topic.title })}
            />
          ))}
        </OptionList>
      )}

      <OptionFooter>
        <BackToLinkButton to="/">← Volver al inicio</BackToLinkButton>
      </OptionFooter>
    </div>
  );
}

export const Topics = memo(InternalTopics);
